var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { AnchorCore, } from '@core-front/anchor';
import { navigate } from '@telia-front/window';
const Anchor = (props) => {
    const { isUnderlined = true, theme, isTextColor, className } = props, rest = __rest(props, ["isUnderlined", "theme", "isTextColor", "className"]);
    const BEM = () => {
        const classArray = [];
        if (theme) {
            classArray.push(`anchor--theme-${theme}`);
        }
        if (theme === 'dark' && isTextColor) {
            classArray.push('anchor--theme-dark-text-color');
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (React.createElement(AnchorCore, Object.assign({ isUnderlined: isUnderlined, isTextColor: isTextColor }, rest, { className: BEM() })));
};
// defaultProps is used for when a component clones Anchor as it's child,
// child.props.onClick would be defined. For example, AnalyticsTrigger.
// React does not fill child.props from ES6 default values.
Anchor.defaultProps = {
    onClick: navigate,
};
export { Anchor as default, };
